import {
  getTravelCheckoutFormValues,
  setSectionMessageVisibility,
} from 'app/services/businessFunctionHelpers';
import { MessagesEnum, FormsEnum } from 'app/shared/enums';
import { TravelerInterface } from 'app/shared/interfaces/Traveler.interface';
import { checkIsDataObfuscated } from '../helpers/checkIsDataObfuscated';

const setObfuscationMessageVisibility = (
  messageKey: MessagesEnum,
  traveler?: Partial<TravelerInterface>
) => {
  const showObfuscatedMessage = [
    traveler?.name,
    traveler?.surname,
    traveler?.pesel,
    traveler?.homeAddress?.zipCode,
    traveler?.homeAddress?.city,
    traveler?.homeAddress?.streetName,
  ].some((item) => checkIsDataObfuscated(item, true));

  setSectionMessageVisibility({
    key: messageKey,
    visible: showObfuscatedMessage,
    formName: FormsEnum.TravelCheckoutForm,
  });
};

export const obfuscation = {
  showTraveler1DataObfuscatedMessage() {
    const {
      travel: { travelers },
    } = getTravelCheckoutFormValues();

    setObfuscationMessageVisibility(
      MessagesEnum.Traveler1DataObfuscated,
      travelers[0]
    );
  },
  showTraveler2DataObfuscatedMessage() {
    const {
      travel: { travelers },
    } = getTravelCheckoutFormValues();

    setObfuscationMessageVisibility(
      MessagesEnum.Traveler2DataObfuscated,
      travelers[1]
    );
  },
  showTraveler3DataObfuscatedMessage() {
    const {
      travel: { travelers },
    } = getTravelCheckoutFormValues();

    setObfuscationMessageVisibility(
      MessagesEnum.Traveler3DataObfuscated,
      travelers[2]
    );
  },
  showTraveler4DataObfuscatedMessage() {
    const {
      travel: { travelers },
    } = getTravelCheckoutFormValues();

    setObfuscationMessageVisibility(
      MessagesEnum.Traveler4DataObfuscated,
      travelers[3]
    );
  },
  showTraveler5DataObfuscatedMessage() {
    const {
      travel: { travelers },
    } = getTravelCheckoutFormValues();

    setObfuscationMessageVisibility(
      MessagesEnum.Traveler5DataObfuscated,
      travelers[4]
    );
  },
  showTraveler6DataObfuscatedMessage() {
    const {
      travel: { travelers },
    } = getTravelCheckoutFormValues();

    setObfuscationMessageVisibility(
      MessagesEnum.Traveler6DataObfuscated,
      travelers[5]
    );
  },
  showTraveler7DataObfuscatedMessage() {
    const {
      travel: { travelers },
    } = getTravelCheckoutFormValues();

    setObfuscationMessageVisibility(
      MessagesEnum.Traveler7DataObfuscated,
      travelers[6]
    );
  },
  showTraveler8DataObfuscatedMessage() {
    const {
      travel: { travelers },
    } = getTravelCheckoutFormValues();

    setObfuscationMessageVisibility(
      MessagesEnum.Traveler8DataObfuscated,
      travelers[7]
    );
  },
  showTraveler9DataObfuscatedMessage() {
    const {
      travel: { travelers },
    } = getTravelCheckoutFormValues();

    setObfuscationMessageVisibility(
      MessagesEnum.Traveler9DataObfuscated,
      travelers[8]
    );
  },
  showTraveler10DataObfuscatedMessage() {
    const {
      travel: { travelers },
    } = getTravelCheckoutFormValues();

    setObfuscationMessageVisibility(
      MessagesEnum.Traveler10DataObfuscated,
      travelers[9]
    );
  },
};
